<template>
  <section class="nft-market">
    <div class="mb-60 lg:mb-0 mt-0 lg:mt-210 py-220 lg:py-400 w-full bg-black relative z-0 overflow-hidden">

      <div class="blex-left w-full pl-16 lg:pl-320">
        <div class="text-white font-bold text-2xl lg:text-6xl bottom-gradient pb-12 z-10">
          NFT MINTING PAGE
        </div>
        <div class="w-full blex-left z-10">
          <a href="https://nft.metarising.io" target="_blank"
             class="text-black bg-white font-semiBold px-20 py-16 lg:py-20 text-normal lg:text-xl blex mt-60 cursor-pointer">
            Go To NFT MINTING PAGE
            <div class="blex pl-8">
              <img src="@/assets/images/icon/rightArrow.svg">
            </div>
          </a>
        </div>
      </div>

      <!--  pfp-container      -->
      <div class="pfp-container">
        <div class="blex pfp-images"></div>
      </div>

      <div class="gradient blex">
        <img src="@/assets/images/pages/main/nftMarket/gra2.png" alt="" class="hidden lg:block w-full h-full">
        <img src="@/assets/images/pages/main/nftMarket/mGra.png" alt="" class="lg:hidden block w-full">
      </div>
    </div>
  </section>

</template>

<script>
import NftMarketCard from '@/views/components/nftMarket/NftMarketCard'

export default {
  name: 'NftMarket',
  data: () => ({}),
  components: {NftMarketCard}
}
</script>

<style scoped lang="scss">
section::v-deep {
  overflow: hidden;

  .pfp-container {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    position: absolute;
    display: flex;
    justify-content: center;
    overflow: hidden;
    perspective: 3000px;
    z-index: -1;
  }

  .gradient {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    //background: linear-gradient(180deg, rgba(0, 0, 0, 1) 15%, rgba(255, 255, 255, 0) 30%, rgba(0, 0, 0, 1) 85%);
    //background: -webkit-linear-gradient(to bottom, rgba(0, 0, 0, 1) 15%, rgba(255, 255, 255, 0) 30%, rgba(0, 0, 0, 1) 85%);
    //background: -moz-linear-gradient(to bottom, rgba(0, 0, 0, 1) 15%, rgba(255, 255, 255, 0) 30%, rgba(0, 0, 0, 1) 85%);
    z-index: 0;

    @media screen and (max-width: 1024px) {
      //background: linear-gradient(180deg, rgba(0, 0, 0, 1) 20%, rgba(255, 255, 255, 0) 50%, rgba(0, 0, 0, 1) 80%);
      //background: -webkit-linear-gradient(to bottom, rgba(0, 0, 0, 1) 20%, rgba(255, 255, 255, 0) 50%, rgba(0, 0, 0, 1) 80%);
      //background: -moz-linear-gradient(to bottom, rgba(0, 0, 0, 1) 20%, rgba(255, 255, 255, 0) 50%, rgba(0, 0, 0, 1) 80%);
    }
  }

  .pfp-images {
    display: flex;
    align-items: start;
    flex-wrap: nowrap;
    white-space: nowrap;
    align-content: start;
    width: 100%;
    transform: scale(1.2);
    animation: slide 12s linear infinite;
    background: url("~@/assets/images/pages/main/nftMarket/pfp.png");
    background-position: center;
    background-repeat: repeat-y;
    background-size: cover;

    @media screen and (max-width: 1024px) {
      background: url("~@/assets/images/pages/main/nftMarket/mPfp.png");
    }

    .market-pfp {
      @media screen and (max-width: 1024px) {
        width: 90px;
      }
    }

    @keyframes slide {

      0% {
        transform: rotateX(45deg) scale(1.2);
        background-position: 0 0;
      }

      100% {
        background-position: 0 -100vh;
        transform: rotateX(45deg) scale(1.2);
      }


    }

  }


  @media screen and (max-width: 1024px) {
    @keyframes slide {

      0% {
        transform: rotateX(45deg) scale(1.2);
        background-position: 0 0;
      }
      100% {
        background-position: 0 -100vh;
        transform: rotateX(45deg) scale(1.2);
      }

    }

  }


}


</style>
